import React, { useState } from 'react';
import { DestinationCard } from './DestinationCard';
import { destinations } from '../data/mock';

export const DestinationsGrid = () => {
  const [selectedRegion, setSelectedRegion] = useState('Todos');
  
  const regions = ['Todos', 'Asia', 'América', 'Especiales', 'Europa'];
  
  const filteredDestinations = selectedRegion === 'Todos' 
    ? destinations 
    : destinations.filter(d => d.region === selectedRegion);

  return (
    <section id="destinos" className="py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Explora nuestros grupos
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Selecciona tu próximo destino y únete a una comunidad de viajeros apasionados
          </p>
        </div>
        
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {regions.map(region => (
            <button
              key={region}
              onClick={() => setSelectedRegion(region)}
              className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                selectedRegion === region
                  ? 'bg-gradient-to-r from-orange-600 to-red-600 text-white shadow-lg scale-105'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {region}
            </button>
          ))}
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredDestinations.map(destination => (
            <DestinationCard key={destination.id} destination={destination} />
          ))}
        </div>
        
        {filteredDestinations.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">No hay destinos disponibles en esta región</p>
          </div>
        )}
      </div>
    </section>
  );
};
